import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'src/app/shared/guards/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { NextRacesComponent } from './pages/next-races/next-races.component';

const routes: Routes = [
  { path: '', redirectTo: 'homepage', pathMatch: 'full' },
  { path: '', component: HomeComponent },
  { path: 'next-races/all', component: NextRacesComponent },
  { path: 'next-races/pmu', component: NextRacesComponent },
  /*   { path: 'allraces', component: AllRacesComponent },
    { path: 'race/:country/:datetime/:track/:time', component: RaceDetailsComponent },
    { path: 'races/:datetime', component: AllRacesComponent },
    { path: 'races/:country/:datetime/:track', component: TrackRacesComponent }, */
];

export const HomeRoutes = RouterModule.forChild(routes);
